require('./bootstrap');
require('./menu');
require('./sliders');
require('./collapse');
require('./forms');
require('./fancybox');
require('./animate');



//require('./video');
//require('./paginate');
/* require('./main');



require('./order');


require('./search'); */